import React from "react";
import { Header } from "antd/es/layout/layout";
import {
  ArrowLeftOutlined,
  ExclamationCircleFilled,
  SaveOutlined,
  FileWordOutlined,
  FilePdfOutlined,
  UploadOutlined,
  CloudSyncOutlined,
  CloudOutlined,
} from "@ant-design/icons";
import { Button, Modal, Col, Row, Typography, Dropdown, Space } from "antd";
import { useNavigate } from "react-router-dom";
const { confirm } = Modal;

const { Text } = Typography;

const Title = (props) => {
  const { title, epNum } = props;

  // const [mouseIn, setMouseIn] = useState(false);
  // const [value, setValue] = useState(title);
  return (
    <Space align="center">
      <Text strong>
        EP{epNum} - {title}
      </Text>
      {/* <div
        style={{ width: "100%" }}
        onMouseEnter={() => setMouseIn(true)}
        onMouseLeave={() => {
          // TODO: save to DB
          setMouseIn(false);
        }}
      >
        <Input
          style={{ background: "#FEFEFE", fontSize: 16, fontWeight: "bold" }}
          value={value || ""}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          placeholder="Titre de l'épisode"
          bordered={mouseIn}
        />
      </div> */}
    </Space>
  );
};

const Back = (props) => {
  const { onClick } = props;
  return (
    <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={onClick} />
  );
};

const Export = (props) => {
  const { onPrint, onDocx } = props;

  const items = [
    {
      key: "docx",
      label: "Exporter en DOCX",
      icon: <FileWordOutlined />,
    },
    {
      key: "pdf",
      label: "Exporter en PDF",
      icon: <FilePdfOutlined />,
    },
  ];

  const onClickMenuItem = (e) => {
    console.log("click", e);
    switch (e.key) {
      case "docx":
        onDocx();
        break;
      case "pdf":
        onPrint();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Dropdown menu={{ items, onClick: onClickMenuItem }}>
        <Button type="text">Exporter</Button>
      </Dropdown>
    </>
  );
};

const Save = (props) => {
  const { onSave, onPublish } = props;

  const items = [
    {
      key: "integrer",
      label: "Intégrer",
      icon: <UploadOutlined />,
    },
    {
      key: "save",
      label: "Enregistrer",
      icon: <SaveOutlined />,
    },
  ];

  const onClickMenuItem = (e) => {
    console.log("click", e);
    switch (e.key) {
      case "integrer":
        onPublish();
        break;
      case "save":
        onSave();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Dropdown menu={{ items, onClick: onClickMenuItem }}>
        <Button style={{ marginLeft: -4 }} type="text">
          Fichier
        </Button>
      </Dropdown>
    </>
  );
};

const HeaderEditor = (props) => {
  const { onSave, onPublish, episode, onPrint, onDocx, isSaving, serie } =
    props;

  const navigate = useNavigate();

  const showDeleteConfirm = () => {
    confirm({
      title: "Es-tu sûr(e) de vouloir intégrer cet épisode ?",
      icon: <ExclamationCircleFilled />,
      content:
        "Si une ancienne intégration existe déjà, elle sera supprimée et remplacée par celle-ci.",
      okText: "Intégrer",
      okType: "danger",
      cancelText: "Annuler",
      onOk() {
        onPublish();
      },
    });
  };

  return (
    <Header
      style={{
        position: "fixed",
        right: 0,
        left: 0,
        background: "#FEFEFE",
        borderRadius: 5,
        zIndex: 1000,
        borderBottomColor: "#E6E6E6",
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        lineHeight: "0px",
        height: 85,
      }}
    >
      <Row
        style={{
          paddingTop: 10,
          paddingBottom: 5,
        }}
      >
        <Col span={1}>
          <Back
            onClick={() =>
              navigate(`/serie/${serie.id}/details`, { state: { serie } })
            }
          />
        </Col>
        <Col flex="auto">
          <Title title={episode.name} epNum={episode.number} />
        </Col>
      </Row>
      <Row align="middle">
        <Col span={1} />
        <Col flex="none">
          <Save onPublish={showDeleteConfirm} onSave={onSave} />
        </Col>
        <Col style={{ paddingRight: 5 }} flex="none">
          <Export onPrint={onPrint} onDocx={onDocx} />
        </Col>
        <Col>
          <Text type="secondary">
            {isSaving ? (
              <CloudSyncOutlined style={{ marginRight: 5 }} />
            ) : (
              <CloudOutlined style={{ marginRight: 5 }} />
            )}
            {isSaving ? "Enregistrement..." : "À jour"}
          </Text>
        </Col>
      </Row>
    </Header>
  );
};

export default HeaderEditor;
